/* bm-search-cards.js: search v2 product cards, grid size, pagination and the zero-results page (16 Oct 2026).
 *
 * Owner: builder B. Pair file: bm-search-cards.css. Builder A owns the filters, stats, sort and phone dialog
 * (bm-search-page.*). Nothing here runs unless the gate snippet put .bm-search-page on <html> first.
 *
 * Algolia app hooks used (all are multi-registration: the app chains every registered function in order):
 *   beforeInstantSearchOptions          hitsPerPage, read by the app's own configure widget
 *   beforeInstantSearchStartAddWidgets  one configure widget: attributesToRetrieve, no snippets, no highlights.
 *                                       Every function on this hook must return all the widgets it was given
 *                                       (recent_items.js adds typoTolerance the same way).
 *   beforeInstantSearchProductTemplate  the card, in the collection card's layout
 *   beforeInstantSearchNoResultTemplate the zero-results page
 *   afterInstantSearchHitClickAction    lets our card link navigate (the app marks this hook "will be deprecated"
 *                                       and logs a warning; if it goes, the app navigates as it does today)
 * Pagination is the app's own widget, restyled in the CSS only.
 *
 * Tracking kept on every card: the app's .ais-hit root with data-algolia-index, -position, -queryid, -objectid,
 * data-handle, data-variant-id, data-distinct and data-product-id; the onClick that calls the app's
 * handleItemClick (saveForConversionTracking: queryID, objectID, product id, read again at Add to cart), also on a
 * middle click (onAuxClick, button 1 only, no second Insights event, no preventDefault); and the
 * InstantSearch item it sits in, whose click sends clickedObjectIDsAfterSearch with the queryID and position.
 */
(function () {
  'use strict';

  // One immutable strings object per call site, as native tagged templates provide.
  // Explicit calls survive Shopify CDN lowering without changing html's interpolations.
  function templateStrings(strings, raw) {
    Object.defineProperty(strings, 'raw', { value: Object.freeze(raw) });
    return Object.freeze(strings);
  }
  var HTML_STRINGS_1 = templateStrings(["<div class=\"ais-hit ais-product bm-sc\" data-algolia-index=\"","\" data-algolia-position=\"","\" data-algolia-queryid=\"","\" data-algolia-objectid=\"","\" data-handle=\"","\" data-variant-id=\"","\" data-distinct=\"","\" data-product-id=\"","\" onClick=\"","\" onAuxClick=\"","\">\n      <a class=\"bm-sc__link\" href=\"","\" data-algolia-index=\"","\" data-algolia-position=\"","\" data-algolia-queryid=\"","\" data-algolia-objectid=\"","\">\n        <div class=\"bm-sc__media\">\n          ","\n          <div class=\"bm-sc__ratio\">\n            ","\n          </div>\n        </div>\n        <div class=\"bm-sc__meta\">\n          <div class=\"bm-sc__main\">\n            <div class=\"bm-sc__title\">\n              ","\n              ","\n              <h2 class=\"bm-sc__text\">","</h2>\n            </div>\n          </div>\n          ","\n        </div>\n      </a>\n    </div>"], ["<div class=\"ais-hit ais-product bm-sc\" data-algolia-index=\"","\" data-algolia-position=\"","\" data-algolia-queryid=\"","\" data-algolia-objectid=\"","\" data-handle=\"","\" data-variant-id=\"","\" data-distinct=\"","\" data-product-id=\"","\" onClick=\"","\" onAuxClick=\"","\">\n      <a class=\"bm-sc__link\" href=\"","\" data-algolia-index=\"","\" data-algolia-position=\"","\" data-algolia-queryid=\"","\" data-algolia-objectid=\"","\">\n        <div class=\"bm-sc__media\">\n          ","\n          <div class=\"bm-sc__ratio\">\n            ","\n          </div>\n        </div>\n        <div class=\"bm-sc__meta\">\n          <div class=\"bm-sc__main\">\n            <div class=\"bm-sc__title\">\n              ","\n              ","\n              <h2 class=\"bm-sc__text\">","</h2>\n            </div>\n          </div>\n          ","\n        </div>\n      </a>\n    </div>"]);
  var HTML_STRINGS_2 = templateStrings(["<div class=\"bm-sc__tags\">","</div>"], ["<div class=\"bm-sc__tags\">","</div>"]);
  var HTML_STRINGS_3 = templateStrings(["<div class=\"","\">","</div>"], ["<div class=\"","\">","</div>"]);
  var HTML_STRINGS_4 = templateStrings(["<img class=\"bm-sc__img\" src=\"","\" srcset=\"","\" sizes=\"","\" alt=\"","\" width=\"","\" height=\"","\" loading=\"","\" fetchpriority=\"","\" decoding=\"async\" />"], ["<img class=\"bm-sc__img\" src=\"","\" srcset=\"","\" sizes=\"","\" alt=\"","\" width=\"","\" height=\"","\" loading=\"","\" fetchpriority=\"","\" decoding=\"async\" />"]);
  var HTML_STRINGS_5 = templateStrings(["<span class=\"bm-sc__lane bm-sc__lane--code\"><span class=\"bm-sc__vh\">Product code </span>","</span>"], ["<span class=\"bm-sc__lane bm-sc__lane--code\"><span class=\"bm-sc__vh\">Product code </span>","</span>"]);
  var HTML_STRINGS_6 = templateStrings(["<span class=\"bm-sc__lane bm-sc__lane--brand\">","</span>"], ["<span class=\"bm-sc__lane bm-sc__lane--brand\">","</span>"]);
  var HTML_STRINGS_7 = templateStrings(["<div class=\"bm-sc__secondary\">\n            <div class=\"","\">\n              ","\n              ","\n              ","\n            </div>\n          </div>"], ["<div class=\"bm-sc__secondary\">\n            <div class=\"","\">\n              ","\n              ","\n              ","\n            </div>\n          </div>"]);
  var HTML_STRINGS_8 = templateStrings(["<span class=\"bm-sc__current\"><span aria-hidden=\"true\">","</span><span class=\"bm-sc__vh\">","</span></span>"], ["<span class=\"bm-sc__current\"><span aria-hidden=\"true\">","</span><span class=\"bm-sc__vh\">","</span></span>"]);
  var HTML_STRINGS_9 = templateStrings(["<span class=\"bm-sc__was\"><span aria-hidden=\"true\">","</span><span class=\"bm-sc__vh\">","</span></span>"], ["<span class=\"bm-sc__was\"><span aria-hidden=\"true\">","</span><span class=\"bm-sc__vh\">","</span></span>"]);
  var HTML_STRINGS_10 = templateStrings(["<span class=\"bm-sc__variant\" title=\"","\">","</span>"], ["<span class=\"bm-sc__variant\" title=\"","\">","</span>"]);
  var HTML_STRINGS_11 = templateStrings(["<div class=\"bm-sc-empty\" role=\"status\">\n      <h2 class=\"bm-sc-empty__title\">","</h2>\n      <p class=\"bm-sc-empty__tips\">Check the spelling, use fewer words or search by product code.","</p>\n      <div class=\"bm-sc-empty__group\">\n        <h3 class=\"bm-sc-empty__head\">Popular searches</h3>\n        <ul class=\"bm-sc-empty__links\">","</ul>\n      </div>\n      <div class=\"bm-sc-empty__group\">\n        <h3 class=\"bm-sc-empty__head\">Shop by category</h3>\n        <ul class=\"bm-sc-empty__links\">","</ul>\n      </div>\n      <p class=\"bm-sc-empty__help\">Need help finding a product? Call <a class=\"bm-sc-empty__inline\" href=\"","\">","</a></p>\n    </div>"], ["<div class=\"bm-sc-empty\" role=\"status\">\n      <h2 class=\"bm-sc-empty__title\">","</h2>\n      <p class=\"bm-sc-empty__tips\">Check the spelling, use fewer words or search by product code.","</p>\n      <div class=\"bm-sc-empty__group\">\n        <h3 class=\"bm-sc-empty__head\">Popular searches</h3>\n        <ul class=\"bm-sc-empty__links\">","</ul>\n      </div>\n      <div class=\"bm-sc-empty__group\">\n        <h3 class=\"bm-sc-empty__head\">Shop by category</h3>\n        <ul class=\"bm-sc-empty__links\">","</ul>\n      </div>\n      <p class=\"bm-sc-empty__help\">Need help finding a product? Call <a class=\"bm-sc-empty__inline\" href=\"","\">","</a></p>\n    </div>"]);
  var HTML_STRINGS_12 = templateStrings(["No results for “","”"], ["No results for “","”"]);
  var HTML_STRINGS_13 = templateStrings([" Or <button type=\"button\" class=\"ais-hit-empty--clear-filters bm-sc-empty__inline\">clear the filters</button>."], [" Or <button type=\"button\" class=\"ais-hit-empty--clear-filters bm-sc-empty__inline\">clear the filters</button>."]);
  var HTML_STRINGS_14 = templateStrings(["<li><a class=\"bm-sc-empty__link\" href=\"","\">","</a></li>"], ["<li><a class=\"bm-sc-empty__link\" href=\"","\">","</a></li>"]);
  var HTML_STRINGS_15 = templateStrings(["<li><a class=\"bm-sc-empty__link\" href=\"","\">","</a></li>"], ["<li><a class=\"bm-sc-empty__link\" href=\"","\">","</a></li>"]);
  var HTML_STRINGS_16 = templateStrings(["<span class=\"bm-sc__off\"><span aria-hidden=\"true\">","</span><span class=\"bm-sc__vh\">","</span></span>"], ["<span class=\"bm-sc__off\"><span aria-hidden=\"true\">","</span><span class=\"bm-sc__vh\">","</span></span>"]);

  var root = document.documentElement;
  if (!root.classList.contains('bm-search-page')) return;

  // ---------- Defaults, pending Carlos and the manager. Each one is a single edit. ----------
  var HITS_PER_PAGE = 20;        // collections show 68; 20 keeps the response small
  var SHOW_VARIANT = true;       // hits are variants (distinct off): name the variant whenever it is a real option
                                 // value, also on a product with one variant, never "Default Title", as search did
                                 // before 16 Oct (Carlos 17 Oct). Turn off once distinct is on.
  var SHOW_BRAND = true;         // Core Rule: the brand stays on the card, in the collection's moniker lane
  var STRIP_VENDOR = true;       // collection rule: a title that starts with the brand drops it (the lane shows it)
  var SHOW_SALE = true;          // Carlos 17 Oct (Core Rule): the was price and the % off come back, as search showed
                                 // them before 16 Oct, styled our way. Was false from 27 Sep.
  var HIGHLIGHT_TITLE = false;   // collection titles are plain text
  var SOLD_OUT_LABEL = true;     // collection rule: "Sold Out" when the item can't be ordered
  var EAGER_CARDS = 4;           // c132: the first 4 images load at once, at high priority
  var CODE_QUERY = /^(?=\S*[a-z])(?=\S*\d)\S{4,}$/i;  // letters and digits mixed, no spaces, 4 or more characters

  // The card, the click and conversion tracking and the app's fallback card need these. Everything else
  // (body_html_safe, collection_ids, category, dates, options, meta, named tags) stays on the server.
  var ATTRIBUTES = [
    'objectID', 'id', 'handle', 'title', 'vendor', 'variant_title', 'product_type', 'sku',
    'price', 'compare_at_price', 'price_ratio', 'variants_min_price', 'variants_max_price', 'variants_count',
    'image', 'product_image', 'tags', 'inventory_available', 'inventory_policy', 'inventory_quantity'
  ];

  // Zero results. Popular searches are hard-coded until Algolia analytics feeds them.
  var POPULAR = ['toilet', 'vanity', 'basin', 'kitchen mixer', 'shower', 'tapware'];
  var CATEGORIES = [
    ['Toilets', '/collections/toilets'],
    ['Vanities', '/collections/vanities'],
    ['Basins', '/collections/bathroom-basins'],
    ['Tapware', '/collections/tapware'],
    ['Kitchen sinks', '/collections/kitchen-sinks'],
    ['Showers', '/collections/bathroom-shower-tapware']
  ];
  var PHONE = { label: '1300 123 122', href: 'tel:1300123122' };

  // Images: the collection card's widths, sizes and same-origin CDN path (boost-pfs-filter.js buildImages).
  var IMAGE_WIDTHS = [280, 360, 540, 720, 1000];
  var IMAGE_SRC_WIDTH = 540;
  var IMAGE_SIZES = '(max-width: 768px) calc(50vw - 18px), (max-width: 1280px) 220px, 266px';
  var SHOP_CDN = /^https?:\/\/cdn\.shopify\.com\/s\/files\/1\/0023\/9881\/4278\//;
  var SOLD_OUT = 'Sold Out';  // locales/en.default.json products.product.sold_out

  function shop() { return window.algoliaShopify || {}; }
  function active() { return root.classList.contains('bm-search-page'); }

  function lastResults() {
    try { var s = shop().instantsearch.search; return s.mainIndex.getResults() || null; } catch (e) { return null; }
  }
  function currentQuery() {
    var r = lastResults();
    if (r && typeof r.query === 'string') return r.query;
    try { return shop().instantsearch.search.helper.state.query || ''; } catch (e) {}
    try { return new URLSearchParams(location.search).get('q') || ''; } catch (e) { return ''; }
  }
  function hasRefinements() {
    try {
      var st = shop().instantsearch.search.helper.state;
      var maps = [st.facetsRefinements, st.disjunctiveFacetsRefinements, st.hierarchicalFacetsRefinements, st.facetsExcludes, st.numericRefinements];
      var some = maps.some(function (m) {
        return m && Object.keys(m).some(function (k) { var v = m[k]; return Array.isArray(v) ? v.length : v && Object.keys(v).length; });
      });
      return some || (st.tagRefinements || []).length > 0;
    } catch (e) { return false; }
  }

  function sized(url, width) {
    var parts = String(url).split('?');
    var path = parts[0].replace(/\.(\w{2,5})$/, '_' + width + 'x.$1');
    return path + (parts.length > 1 ? '?' + parts.slice(1).join('?') : '');
  }
  function imageOf(hit) {
    var url = hit.image || hit.product_image;
    if (!url) return null;
    var base = String(url).replace(SHOP_CDN, location.origin + '/cdn/shop/');
    return {
      src: sized(base, IMAGE_SRC_WIDTH),
      srcset: IMAGE_WIDTHS.map(function (w) { return sized(base, w) + ' ' + w + 'w'; }).join(', '),
    };
  }

  // Collection rule (boost-pfs-filter.js): a title that starts with the brand loses it. Only when the moniker lane
  // shows the brand: on a code search the lane shows the code, so the title keeps its brand.
  function titleOf(hit, laneHasBrand) {
    var title = String(hit.title || '');
    var vendor = String(hit.vendor || '');
    if (STRIP_VENDOR && laneHasBrand && vendor && title.toLowerCase().indexOf(vendor.toLowerCase()) === 0) {
      var cut = title.slice(vendor.length).trim();
      if (cut) title = cut;
    }
    return title;
  }
  // Any real option value, whatever the variant count. Shopify names the lone variant of a product with no options
  // "Default Title": that, "Default" and a blank show nothing.
  function variantOf(hit) {
    var v = String(hit.variant_title || '').trim();
    if (!SHOW_VARIANT || hit._distinct) return '';
    return v && !/^default( title)?$/i.test(v) ? v : '';
  }

  // A price is a finite number. null, undefined, blank, booleans and anything non-finite mean "no price", so the
  // card shows no price line rather than $NaN or $0. A real 0 is kept.
  function priceValue(value) {
    if (value === null || value === undefined || typeof value === 'boolean') return null;
    if (typeof value === 'string' && value.trim() === '') return null;
    var n = Number(value);
    return isFinite(n) ? n : null;
  }

  // Collection rule: formatted price with a whole-dollar ".00" dropped, the full price for screen readers.
  function money(amount) {
    var s = shop();
    var cents = Math.round(Number(amount) * 100);
    try { if (typeof s.formatMoney === 'function') return s.formatMoney(cents); } catch (e) {}
    return '$' + (cents / 100).toLocaleString('en', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  }
  // Sale: the hit's compare_at_price above its price (both are the variant's). The was price drops ".00" like the
  // price. The % off is whole cents, rounded down so it never says more than the real saving (the old search card
  // rounded down too), and shows only from 1%.
  function priceParts(hit) {
    var price = priceValue(hit.price);
    if (price === null) return null;
    var full = money(price);
    var parts = { shown: full.replace(/\.00(?!\d)/, ''), full: full, was: '', wasFull: '', off: 0 };
    var compare = priceValue(hit.compare_at_price);
    if (SHOW_SALE && compare !== null && compare > price) {
      parts.wasFull = money(compare);
      parts.was = parts.wasFull.replace(/\.00(?!\d)/, '');
      var priceCents = Math.round(price * 100), compareCents = Math.round(compare * 100);
      if (price > 0 && compareCents > priceCents) parts.off = Math.floor((compareCents - priceCents) * 100 / compareCents);
    }
    return parts;
  }
  function priceRow(price, html) {
    return html(HTML_STRINGS_7, 'bm-sc__price' + (price.was ? ' bm-sc__price--sale' : ''),
      html(HTML_STRINGS_8, price.shown, price.full),
      price.was ? html(HTML_STRINGS_9, price.was, 'Regular price ' + price.wasFull) : '',
      price.was && price.off >= 1 ? html(HTML_STRINGS_16, '\u2212' + price.off + '%', price.off + '% off') : '');
  }

  function labelsOf(hit) {
    var out = (Array.isArray(hit.tags) ? hit.tags : []).filter(function (t) { return typeof t === 'string' && t.indexOf('_label_') === 0; })
      .map(function (t) { return { text: t.replace('_label_', ''), sold: false }; });
    if (SOLD_OUT_LABEL && hit.can_order === false) out.push({ text: SOLD_OUT, sold: true });
    return out;
  }

  function card(hit, html, components, onItemClick) {
    var query = currentQuery().trim();
    var code = CODE_QUERY.test(query) && hit.sku ? String(hit.sku) : '';
    var brand = !code && SHOW_BRAND && hit.vendor ? String(hit.vendor) : '';
    var image = imageOf(hit);
    var title = titleOf(hit, !!brand);
    var variant = variantOf(hit);
    var price = priceParts(hit);
    var labels = labelsOf(hit);
    var position = Number(hit.productPosition);
    var eager = position > 0 && (position - 1) % HITS_PER_PAGE < EAGER_CARDS;
    var link = shop().helpers.instantsearchLink(hit);
    var titleNode = HIGHLIGHT_TITLE && components && components.Highlight && hit._highlightResult && hit._highlightResult.title && title === hit.title
      ? components.Highlight({ attribute: 'title', hit: hit }) : title;

    return html(HTML_STRINGS_1, hit.index, hit.productPosition, hit.queryID, hit.objectID, hit.handle, hit.objectID, hit._distinct, hit.id, function () { if (typeof onItemClick === 'function') onItemClick(hit); }, function (event) { if (event && event.button === 1 && typeof onItemClick === 'function') onItemClick(hit); }, link, hit.index, hit.productPosition, hit.queryID, hit.objectID, labels.length ? html(HTML_STRINGS_2, labels.map(function (l) { return html(HTML_STRINGS_3, 'bm-sc__tag' + (l.sold ? ' bm-sc__tag--sold-out' : ''), l.text); })) : '', image ? html(HTML_STRINGS_4, image.src, image.srcset, IMAGE_SIZES, title, IMAGE_SRC_WIDTH, IMAGE_SRC_WIDTH, eager ? 'eager' : 'lazy', eager ? 'high' : 'auto') : '', code ? html(HTML_STRINGS_5, code) : '', brand ? html(HTML_STRINGS_6, brand) : '', variant ? [titleNode, ' ', html(HTML_STRINGS_10, variant, variant)] : titleNode, price ? priceRow(price, html) : '');
  }

  // The app's own click handler clears the refinements for .ais-hit-empty--clear-filters (delegated on the hits
  // container), so the button needs no handler of ours. Nothing new is tracked.
  function emptyPage(html) {
    var query = currentQuery().trim();
    var refined = hasRefinements();
    return html(HTML_STRINGS_11, query ? html(HTML_STRINGS_12, query) : 'No results', refined ? html(HTML_STRINGS_13) : '', POPULAR.map(function (q) { return html(HTML_STRINGS_14, '/search?q=' + encodeURIComponent(q), q); }), CATEGORIES.map(function (c) { return html(HTML_STRINGS_15, c[1], c[0]); }), PHONE.href, PHONE.label);
  }

  var registered = false;
  function register() {
    var s = shop();
    if (registered || !active() || !s.hooks || typeof s.hooks.registerHook !== 'function') return;
    registered = true;
    var hooks = s.hooks;

    // The app preloads the first 4 images at its own 125px size on phones; our cards ask for the collection's
    // sizes, so those preloads would be fetched for nothing. Our first 4 images are eager and high priority.
    s.has_preloaded_images = true;

    hooks.registerHook('beforeInstantSearchOptions', function (options) {
      if (!active() || !options) return options;
      options.hitsPerPage = HITS_PER_PAGE;
      return options;
    });

    hooks.registerHook('beforeInstantSearchStartAddWidgets', function () {
      var widgets = Array.prototype.slice.call(arguments);
      var configure = s.externals && s.externals.widgets && s.externals.widgets.configure;
      if (!active() || typeof configure !== 'function') return widgets;
      widgets.push(configure({
        attributesToRetrieve: ATTRIBUTES,
        attributesToSnippet: [],
        attributesToHighlight: HIGHLIGHT_TITLE ? ['title'] : [],
      }));
      return widgets;
    });

    // Product-level cards (colour swatches) and distinct results keep the app's card: this store uses neither.
    hooks.registerHook('beforeInstantSearchProductTemplate', function (template, hit, html, components, onItemClick) {
      if (!active() || !hit || typeof html !== 'function' || hit._productLevel || hit._distinct) return template;
      return card(hit, html, components, onItemClick);
    });

    hooks.registerHook('beforeInstantSearchNoResultTemplate', function (template, html) {
      if (!active() || typeof html !== 'function') return template;
      return emptyPage(html);
    });

    // The app's hit click handler still runs on every click (it fires algolia.instantsearch.hitClickAction), then
    // sets location.href itself. When the click landed on our card link, the link navigates instead, as on the
    // collection: one navigation, and Ctrl or Cmd click opens a new tab without moving this one. Any other click
    // (the card's 1px edge) keeps the app's navigation. Insights and conversion tracking are separate handlers.
    hooks.registerHook('afterInstantSearchHitClickAction', function (action) {
      if (!active() || !lastClickOnLink) return action;
      lastClickOnLink = false;
      return function () {};
    });
  }

  var lastClickOnLink = false;
  document.addEventListener('click', function (event) {
    var t = event.target;
    lastClickOnLink = !!(active() && t && t.closest && t.closest('.ais-hit.bm-sc a[href]'));
  }, true);

  if (shop().hooks_has_initialize) register();
  document.addEventListener('algolia.hooks.initialize', register);
})();
